module.exports = __webpack_public_path__ + "static/media/facebookapp.8d02990a.png";